import React from "react";
import services from "../GatewayCountryLogs/services";
import getColumn from "../GatewayCountryLogs/column";
import { Layout, Row, Spin, Table, Modal, Button } from "antd";
import FilterForm from "../GatewayCountryLogs/form";

const { Content } = Layout;

class GatewayCountryLogsModal extends React.Component {
  state = {
    loading: true,
    dataSource: [],
    countryList: [],
    gatewayList: [],
    adminList: [],
    member: null,
    defaultSearch: null,
  };

  currentPage = 1;
  currentSearch = "";
  limit = 10;
  totalRows = 0;

  async componentDidMount() {
    const { gatewayList, countryList, data } = this.props;
    const adminList = await services.getAdminLists();
    const defaultSearch = { member_id: data.memberId };
    this.currentSearch = JSON.stringify(defaultSearch);
    const { totalRows, dataSource } = await services.getGatwayCountryLogsLists(
      this.currentPage,
      this.limit,
      this.currentSearch
    );

    this.totalRows = totalRows;

    this.setState({
      loading: false,
      dataSource,
      countryList: countryList,
      gatewayList: gatewayList,
      adminList: adminList.list,
      member: data,
      defaultSearch,
    });
  }

  afterFormSubmit = (value) => {
    let tmp;
    if (value) {
      tmp = JSON.parse(value);
      tmp = { ...this.state.defaultSearch, ...tmp };

      if (tmp["created_by"]) {
        tmp["created_by"] = `${tmp["created_by"]}`;
      }
    } else {
      tmp = this.state.defaultSearch;
    }

    this.currentSearch = JSON.stringify(tmp);
    this.changePage(this.currentPage, this.limit);
  };

  changePage = async (page, limit) => {
    this.setState({ loading: true });
    this.currentPage = page;
    this.limit = limit;

    const { dataSource, totalRows } = await services.getGatwayCountryLogsLists(
      page,
      limit,
      this.currentSearch
    );

    if (totalRows > 0 && dataSource.length === 0) {
      this.changePage(1, this.limit);
      this.setState({ loading: false });
    }

    this.totalRows = totalRows;
    this.setState({
      dataSource,
      loading: false,
    });
  };

  render() {
    const propsTable = {
      className: "my-table",
      columns: getColumn(this.state.countryList, this.state.gatewayList),
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize: this.limit,
        total: this.totalRows,
        current: this.currentPage,
        onChange: this.changePage,
        size: "small",
      },
    };

    const { data, onCancel, visible } = this.props;
    let title =
      "Gateway Configuration Route Logs" +
      (data && data.memberName ? " ของ " + data.memberName : "");

    return (
      <Modal
        className="my-layout"
        visible={visible}
        maskClosable={false}
        onCancel={onCancel}
        title={title}
        width={800}
        footer={[
          <Button key="cancel" onClick={onCancel}>
            ปิด
          </Button>,
        ]}
        style={{ top: 20 }}
      >
        <Layout className="my-layout">
          <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
            <FilterForm
              adminList={this.state.adminList}
              countryList={this.state.countryList}
              onSubmit={(v) => this.afterFormSubmit(v)}
            />
            <Content
              style={{
                background: "#fff",
                padding: 24,
                margin: "16px 0",
                minHeight: 300,
              }}
            >
              <Row className="utility-bar-mobile"></Row>
              <Table {...propsTable} />
              {/* <Table {...propsTableForMobile} /> */}
            </Content>
          </Spin>
        </Layout>
      </Modal>
    );
  }
}

export default GatewayCountryLogsModal;



// WEBPACK FOOTER //
// ./src/containers/User/GatewayLogsModal.js